// Show popup and overlay
$(".Click-here").on('click', function () {
  $(".custom-model-main").show().addClass('model-open'); // Show popup with fade-in effect
  $(".bg-overlay").show(); // Show overlay with fade-in effect
});

// Close popup and overlay
$(".close-btn, .bg-overlay").on('click', function () {
  $(".custom-model-main").hide().removeClass('model-open'); // Hide popup with fade-out effect
  $(".bg-overlay").hide(); // Hide overlay with fade-out effect
});





document.addEventListener('DOMContentLoaded', function () {
  const colorSelectors = document.querySelectorAll('.color_radio');

  colorSelectors.forEach(selector => {
    selector.addEventListener('change', function () {
      const productId = this.name.split('_')[2];
      const selectedColor = this.dataset.color;

      // Update the product card's image or other details dynamically
      const productImage = document.querySelector(`#product-card-image-${productId}`);
      const selectedVariantImage = document.querySelector(`#variant-image-${this.value}`);

      if (productImage && selectedVariantImage) {
        productImage.src = selectedVariantImage.src; // Update the product image
      }

      // Optional: Update product title or any other content
      const productTitle = document.querySelector(`#product-title-${productId}`);
      if (productTitle) {
        productTitle.textContent = `${productTitle.dataset.baseTitle} - ${selectedColor}`;
      }
    });
  });
});


// $(document).on('click', '.pro-heading h5', function() {
//     var $accordionWrapper = $(this).parents('.pro-accordion-wrp');
//     var isActive = $accordionWrapper.hasClass('active');
    
//     // Remove 'active' from all
//     $('.pro-accordion-wrp').removeClass('active');
    
//     // Toggle 'active' for the clicked one
//     if (!isActive) {
//         $accordionWrapper.addClass('active');
//     }
// });





// $('.pro-heading h5').click(function() {
//     var active = $(this).parents('.pro-accordion-wrp').hasClass('active');
//     if (active) {
//         $(this).parents('.pro-accordion-wrp').removeClass('active');
//     } else {
//         $('.pro-accordion-wrp').removeClass('active'); // Removes 'active' from all
//         $(this).parents('.pro-accordion-wrp').addClass('active'); // Adds 'active' to the clicked one
//     }
// });

$('.faq-accordion-heading h4').click(function () {
    var $parent = $(this).closest('.faq-innr-sec');
    
    if ($parent.hasClass('active')) {
        // If already active, remove the 'active' class
        $parent.removeClass('active');
    } else {
        // Remove 'active' class from all, then add to the clicked element's parent
        $('.faq-innr-sec').removeClass('active');
        $parent.addClass('active');
    }
});


// $('.home-gallery-slider-otr').slick({
//   dots: false,
//   arrows:true,
//   autoplay:true,
//   infinite: true,
//    centerMode: true,
//   // variableWidth: true,
//   centerPadding: '20px',
//    autoplaySpeed:1500,
//   //   prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0677/4495/6585/files/arrow-left.png?v=1732361064"></div>',
//   // nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0677/4495/6585/files/arrow-left_5ae1a0a4-064c-4832-bb5d-e4df789e499e.png?v=1732361069"></div>',
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 4,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     }

//   ]
// });


$('.banner-slider-otr').slick({
  dots: false,
  arrows:true,
  autoplay:true,
  infinite: false,
   autoplaySpeed:1500,
    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0677/4495/6585/files/arrow-left.png?v=1732361064"></div>',
  nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0677/4495/6585/files/arrow-left_5ae1a0a4-064c-4832-bb5d-e4df789e499e.png?v=1732361069"></div>',
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});



// $('.featured_slider').slick({
//   dots: false,
//   arrows:true,
//   autoplay:false,
//   infinite: false,
//    autoplaySpeed:1500,
//     prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0677/4495/6585/files/Group_213.png?v=1732533279"></div>',
//   nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0677/4495/6585/files/Group_13.png?v=1732533279"></div>',
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//           // centerPadding: '20px',
//          // centerMode: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }

//   ]
// });

$(document).ready(function(){
var counter = Number($(".wishlist_counter").text());

  $(document).on('click', '.main_wishList', function() {
  var keyid = $(this).attr('id');
  var valid = $(this).attr('data-id'); 
  var add = $(this).attr('data-rom');
  localStorage.setItem(keyid, valid);
   
   let wishfind = localStorage.getItem(keyid);
       if(wishfind == valid){
         $(this).addClass('active');
       }
    $(`#${add}`).addClass('active');
    
    counter++;
  
  $(".wishlist_counter").text(counter);
    if (counter < 1) {
        $(".wishlist_counter").hide();
    } else {
        $(".wishlist_counter").show();
    }
  });
 


 $('.main_wishList').each(function() {
    var keyid = $(this).attr('id');
    var valid = $(this).attr('data-id');
    var add = $(this).attr('data-rom');
    let wishfind = localStorage.getItem(keyid);

    if (wishfind == valid) {
      $(this).addClass('active'); 
      $(`#${add}`).addClass('active'); 
    }
    
  });

$(document).on('click', '.wishlist-remove', function() {
    var remove = $(this).attr('data-id');
    
    if (localStorage.getItem(remove)) {
        localStorage.removeItem(remove);
        console.log(`Item with ID ${remove} has been removed from localStorage.`);
    } else {
        console.log(`Item with ID ${remove} does not exist in localStorage.`);
    }

     $(this).closest('.wishlist-item').remove();


     $(`#${remove}`).removeClass('active');
     $(this).removeClass('active');

     counter--;
  
   $(".wishlist_counter").text(counter);

    if (counter < 1) {
        $(".wishlist_counter").hide();
    } else {
        $(".wishlist_counter").show();
    }
});


 });

$(".card-wrapper .nav-secton, .main_wishList,.wishlist-remove").hover(function(){
  $('.card__content .quick-add.no-js-hidden .quick-add__submit').addClass("introclass");
  }, function(){
    $('.card__content .quick-add.no-js-hidden .quick-add__submit').removeClass("introclass");

});


$(document).ready(function () {
    $(".card-wrapper").each(function () {
        const $card = $(this);
        const $slides = $card.find(".image_show_option");
        let counter = 0;

        // Function to update the position of the visible slides (to simulate sliding)
        function updateSlidePositions() {
            const visibleSlides = $slides.filter(":visible");
            visibleSlides.each(function (index) {
                $(this).css("transform", `translateX(${(index - counter) * 100}%)`);
            });
        }

        // Function to filter and show images based on colorId
        function filterImages(colorId) {
            const matchingSlides = $slides.filter(`[data-color="${colorId}"]`);
            if (matchingSlides.length > 0) {
                $slides.hide(); // Hide all images
                matchingSlides.show(); // Show only matching images
                counter = 0; // Reset counter to the first visible image
                updateSlidePositions(); // Update positions for the filtered images
            }
        }

        // Event listener for "prev" button to move to the previous slide
        $card.find(".prev").on("click", function () {
            const visibleSlides = $slides.filter(":visible");
            const totalSlides = visibleSlides.length;
            counter = (counter === 0) ? totalSlides - 1 : counter - 1; // Wrap around
            updateSlidePositions(); // Update positions after changing the counter
        });

        // Event listener for "next" button to move to the next slide
        $card.find(".next").on("click", function () {
            const visibleSlides = $slides.filter(":visible");
            const totalSlides = visibleSlides.length;
            counter = (counter === totalSlides - 1) ? 0 : counter + 1; // Wrap around
            updateSlidePositions(); // Update positions after changing the counter
        });

        // Event listener for color swatches to filter images based on color
        $card.find(".color_childe").on("click", function () {
            const colorId = $(this).data("id");
            filterImages(colorId); // Filter images based on the selected color
        });

        // Default behavior: show only the images of the first color group
        const firstColor = $slides.first().data("color");
        filterImages(firstColor); // Initially filter to show only the first color group
    });
});

$(document).ready(function () {
  $(document).on("click", ".mobile-facets__wrapper .sort_filter_mobile", function () {
     $(".option_filter").toggle();
   
   });
   
});


$(document).ready(function() {
  // Attach click event handler to each span element
  $('.option_filter span').on('click', function() {
    // Get the text of the clicked element, clean and format it to match the required query params
    var sortOption = $(this).text().trim().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');

    // Base URL for filter (without the actual sorting part yet)
    var baseUrl = '?filter.v.price.gte=&filter.v.price.lte=&sort_by=';

    // Check the specific text of the clicked span and modify the sort option accordingly
    switch (sortOption) {
      case 'featured':
        sortOption = 'manual';
        break;
      case 'best-selling':
        sortOption = 'best-selling';
        break;
      case 'alphabetically-a-z':
        sortOption = 'title-ascending';
        break;
      case 'alphabetically-z-a':
        sortOption = 'title-descending';
        break;
      case 'price-low-to-high':
        sortOption = 'price-ascending';
        break;
      case 'price-high-to-low':
        sortOption = 'price-descending';
        break;
      case 'date-old-to-new':
        sortOption = 'created-ascending';
        break;
      case 'date-new-to-old':
        sortOption = 'created-descending';
        break;
      default:
        sortOption = 'manual'; // Default to 'manual' if no match found
    }

    // Construct the final URL
    var newUrl = baseUrl + sortOption;

    // Update the URL and refresh the page
    window.location.href = newUrl; // This will reload the page with the new URL
  });
});








